module.exports = __webpack_public_path__ + "img/170-170-CMS 4_3.719c14a9.png";